import { XMarkIcon } from '@heroicons/react/24/outline';
import type { SupervisorFindingWithRow } from '@avisoma/shared';
import { useContext } from 'react';
import { Button } from '../../../catalyst/button';
import { Dialog, DialogBody, DialogTitle } from '../../../catalyst/dialog';
import { CollapsibleYamlView } from '../../CollapsibleYamlView';
import { FindingRevertButton } from '../../FindingRevertButton';
import { SupervisorFindingBadge } from '../../SupervisorFindingBadge';
import { FindingRevertContext } from '../../supervisorFindingRevert';

export function RowInspectorDialog({
  open,
  onClose,
  title,
  data,
  findings,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  data: unknown;
  /** Supervisor findings on this row, listed under the YAML view. */
  findings?: SupervisorFindingWithRow[];
}) {
  const revert = useContext(FindingRevertContext);
  return (
    <Dialog open={open} onClose={onClose} size="5xl">
      <DialogTitle className="flex justify-between items-center">
        {title}
        <Button outline onClick={onClose}>
          <XMarkIcon className="size-4" />
        </Button>
      </DialogTitle>
      <DialogBody>
        <CollapsibleYamlView data={data} />
        {findings && findings.length > 0 && (
          <section className="mt-4">
            <h4 className="mb-2 text-sm font-medium text-gray-700 dark:text-zinc-200">Supervisor findings</h4>
            <ul className="space-y-1">
              {findings.map((f) => (
                <li key={f.id} className="flex flex-wrap items-baseline gap-2">
                  {/* The hover popover portals outside this dialog's panel, where a click closes the
                      dialog; the badge stays read-only here and Revert sits inline. */}
                  <FindingRevertContext.Provider value={null}>
                    <SupervisorFindingBadge finding={f} />
                  </FindingRevertContext.Provider>
                  <span className="text-xs text-gray-500 dark:text-zinc-400">{f.reason}</span>
                  <FindingRevertButton finding={f} handle={revert} />
                </li>
              ))}
            </ul>
          </section>
        )}
      </DialogBody>
    </Dialog>
  );
}
